/*
 * TurnCancellationButton Messages
 *
 * This contains all the text for the TurnCancellationButton component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  turnCanceled: {
    id: 'app.components.TurnCanceledView.turnCanceled',
    defaultMessage: 'Turn canceled',
  },
});
